module.exports = __webpack_public_path__ + "static/media/truck_blue.ddd9d0f7.svg";